import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import Unity, { RegisterExternalListener, UnityEvent } from 'react-unity-webgl';

import Header from '../Header/Header';

import * as actions from '../../actions/index';

import './UnityContent.css';

const initialState = {
  currentView: 0,
  title: "ABB Power Grids Service",
  subtitle: "Overview"
}

class UnityContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;

    this.onProgress = this.onProgress.bind(this);

    this.loaded = false;

    this.loadScene = new UnityEvent('NativeCommunication', 'LoadScene');
    // this.goNext = new UnityEvent('NativeCommunication', 'GoNext');

    RegisterExternalListener('onSceneLoaded', sceneName => this.onSceneLoaded(sceneName));
    RegisterExternalListener('setContent', name => this.setContent(name));
  }

  componentWillMount() {
    this.props.setLoader(true);
  }

  onProgress(progression) {
    this.props.setUnityProgress(Math.ceil(progression * 100));
    // if (progression === 1) {
    //   console.log('progression', progression, 'loading MainScene')
    //   this.loadScene.emit('MainScene');
    // }
  }

  setContent(name) {
    const slugs = ["ServiceMission", "PowerCare", "CustomerCare", "IndustrySector", "PrimaryEquipment", "ServiceOffering"];
    const section = slugs.indexOf(name);

    console.log('Want to navigate to', name, section + 1);
    if(section > -1) {
      this.props.goToSection(section + 1);
    }
    
    // console.log('Want to setContent', name);
  }
  onSceneLoaded(sceneName, nextProps) {
    console.log('Loaded scene', sceneName);
    if(sceneName === 'MainScene') {
      this.props.setLoader(false);
    } else {
      this.loadScene.emit('MainScene');
    }
  }

  render() {
    const props = this.props;
    return (
      <section ref="outerSection" className={`unityContent ${props.unityDisplay ? 'showing' : ''}`}>
        {this.state.title &&
          <Header title={this.state.title} subtitle={this.state.subtitle} type='home'/>
        }
        <Unity
          src="assets/Unity/Build/WebGL.json"
          loader="assets/Unity/Build/UnityLoader.js"
          width="100%"
          onProgress={this.onProgress}
        />
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentSection: state.navigation.currentSection,
    currentGroup: state.navigation.currentGroup,
    currentStage: state.navigation.currentStage,
    unitySceneCalled: state.navigation.unitySceneCalled,
    unityDisplay: state.navigation.unityDisplay,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setLoader: (bool) => {
      dispatch(actions.setLoader(bool));
    },
    setModal: (index) => {
      dispatch(actions.setModal(index));
    },
    goToGroup: (id) => {
      dispatch(actions.goToGroup(id));
    },
    goToSection: (id) => {
      dispatch(actions.goToSection(id));
    },
    goToStage: (id) => {
      dispatch(actions.goToStage(id));
    },
    setUnityDisplay: (bool) => {
      dispatch(actions.setUnityDisplay(bool));
    },
    setUnityProgress: (percentage) => {
      dispatch(actions.setUnityProgress(percentage));
    }
  };
}


UnityContent.propTypes = {
  setLoader: propTypes.func.isRequired,
  setUnityDisplay: propTypes.func.isRequired,
  unitySceneCalled: propTypes.number,
  setUnityProgress: propTypes.func.isRequired,
  data: propTypes.object.isRequired,
  currentStage: propTypes.number,
  currentGroup: propTypes.number,
  currentSection: propTypes.number.isRequired,
  unityDisplay: propTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnityContent);



// WEBPACK FOOTER //
// ./src/components/UnityContent/UnityContent.js